import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTiktokLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8358_3111)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M11.3427 16.6556C8.74549 16.6556 6.64722 18.714 6.68561 21.2369C6.7112 22.856 7.61959 24.2618 8.9566 25.0462C8.5024 24.3622 8.23372 23.5526 8.22092 22.6803C8.18254 20.1574 10.2808 18.099 12.878 18.099C13.3898 18.099 13.8824 18.1806 14.343 18.3249V13.2729C13.8632 13.2039 13.3706 13.1663 12.878 13.1663C12.8525 13.1663 12.8333 13.1663 12.8077 13.1663V16.8815C12.3471 16.7372 11.8545 16.6556 11.3427 16.6556Z",
				fill: "#F00044"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.5699 1.50592H22.5315H21.2009C21.5848 3.39492 22.6659 5.03916 24.1756 6.15624C23.184 4.86972 22.5827 3.26313 22.5699 1.50592Z",
				fill: "#F00044"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M30.3999 9.19373C29.8945 9.19373 29.4084 9.14352 28.9286 9.05566V12.6768C27.1885 12.6768 25.4997 12.3442 23.9132 11.6789C22.8897 11.2522 21.9365 10.7062 21.0601 10.0472L21.0857 21.2118C21.0729 23.7221 20.0621 26.0755 18.2325 27.8515C16.742 29.2949 14.8548 30.2175 12.8078 30.5124C12.328 30.5815 11.8354 30.6191 11.3428 30.6191C9.15498 30.6191 7.06951 29.9225 5.37427 28.636C5.56618 28.8619 5.77089 29.0816 5.99479 29.2949C7.83717 31.0772 10.2809 32.0625 12.8845 32.0625C13.3771 32.0625 13.8697 32.0249 14.3495 31.9558C16.3966 31.6609 18.2837 30.7383 19.7743 29.2949C21.6038 27.5189 22.6146 25.1655 22.6274 22.6552L22.5314 11.4907C23.4014 12.1496 24.3546 12.7019 25.3846 13.1223C26.9774 13.7813 28.6663 14.1202 30.3999 14.1202",
				fill: "#F00044"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.97563 15.9464C7.79881 14.1704 10.2233 13.1851 12.8078 13.1663V11.8295C12.328 11.7605 11.8354 11.7228 11.3428 11.7228C8.7328 11.7228 6.28269 12.7081 4.44031 14.503C2.62992 16.2665 1.59358 18.6764 1.59997 21.1804C1.59997 23.7032 2.61712 26.0692 4.4531 27.8578C4.74737 28.1402 5.04804 28.4038 5.3679 28.6422C3.92214 26.9541 3.13529 24.8454 3.12889 22.6238C3.13529 20.1198 4.16523 17.7099 5.97563 15.9464Z",
				fill: "#08FFF9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M28.9286 9.05564V7.71263H28.9158C27.1374 7.71263 25.4997 7.13526 24.1819 6.15625C25.327 7.63732 27.003 8.69165 28.9286 9.05564Z",
				fill: "#08FFF9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.6158 27.1235C13.2236 27.1549 13.8057 27.0733 14.3431 26.9038C16.1982 26.3076 17.5352 24.6132 17.5352 22.6175L17.5416 15.1494V1.50592H21.2008C21.1048 1.03524 21.0537 0.558284 21.0473 0.0625H16.0063V13.6997L15.9999 21.1678C15.9999 23.1635 14.6629 24.858 12.8077 25.4541C12.2704 25.6299 11.6882 25.7115 11.0805 25.6738C10.3065 25.6299 9.58359 25.4039 8.95667 25.0399C9.74351 26.2323 11.0869 27.0419 12.6158 27.1235Z",
				fill: "#08FFF9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.8078 30.5124C14.8549 30.2174 16.742 29.2949 18.2326 27.8515C20.0621 26.0754 21.0729 23.722 21.0857 21.2117L21.0601 10.0472C21.9301 10.7062 22.8833 11.2584 23.9132 11.6789C25.5061 12.3378 27.195 12.6767 28.9286 12.6767V9.05564C27.0031 8.69164 25.327 7.63732 24.1819 6.15624C22.6722 5.03916 21.5847 3.39492 21.2072 1.50592H17.5417V15.1431L17.5353 22.6112C17.5353 24.6069 16.1983 26.3014 14.3431 26.8976C13.8057 27.0733 13.2236 27.1549 12.6159 27.1172C11.0805 27.0356 9.74354 26.2261 8.95669 25.0399C7.61969 24.2618 6.71129 22.8497 6.6857 21.2306C6.64732 18.7077 8.74558 16.6493 11.3428 16.6493C11.8546 16.6493 12.3472 16.7309 12.8078 16.8752V13.16C10.2233 13.1788 7.79881 14.1641 5.97562 15.9401C4.16522 17.7036 3.12889 20.1135 3.13528 22.6112C3.13528 24.8328 3.92213 26.9415 5.37429 28.6297C7.07593 29.9162 9.155 30.6128 11.3428 30.6128C11.8354 30.6191 12.328 30.5814 12.8078 30.5124Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8358_3111",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white"
		})
	}) })]
});
export default SvgTiktokLight;
